"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternalUser = exports.isAllowedToConsumePaidContent = void 0;
var users_1 = require("@livv/models/consts/users");
var isAllowedToConsumePaidContent = function (_a, isEmailVerified) {
    var isPaidCustomer = _a.isPaidCustomer, role = _a.role, trialEndDate = _a.trialEndDate;
    return isEmailVerified &&
        (role === 'admin' || isPaidCustomer || (trialEndDate ? trialEndDate > Date.now() : false));
};
exports.isAllowedToConsumePaidContent = isAllowedToConsumePaidContent;
/**
 * Determines whether a user is considered an internal user based on their email address.
 *
 * An internal user is defined as one whose email address ends with the configured
 * {@link INTERNAL_EMAIL_SUFFIX}. If the provided email is `null`, `undefined`, or an
 * otherwise falsy value, this function returns `false`.
 *
 * @param email - The user's email address. May be a string, `null`, or `undefined`.
 * @returns `true` if the email is a non-empty string whose lowercase value ends with
 *          {@link INTERNAL_EMAIL_SUFFIX}; otherwise, `false`.
 */
var isInternalUser = function (email) {
    return !!email && email.toLowerCase().endsWith(users_1.INTERNAL_EMAIL_SUFFIX);
};
exports.isInternalUser = isInternalUser;
//# sourceMappingURL=users.js.map